import React, { Component } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Icon from 'oxyrion-ui/lib/Icon';

class InfoWithTooltip extends Component {
  render() {
    return (
      <Wrapper
        width={
          this.props.width ||
          (this.props.children ? this.props.children.length * 5 : 0)
        }
      >
        <div className="tooltip">
          <Icon color={this.props.color} name="info" size="l" />
          <span className="tooltiptext">{this.props.children}</span>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  margin-right: ${rem(4)};
  margin-left: ${rem(4)};
  cursor: pointer;
  .tooltip {
    position: relative;
    display: inline-block;
    width: ${rem(16)};
    height: ${rem(16)};
  }

  .tooltip .tooltiptext {
    display: none;
    background-color: black;
    width: ${rem(420)};
    color: #fff;
    text-align: center;
    padding: 8px 8px;
    border-radius: ${rem(24)};
    font-size: ${rem(12)};
    top: -12px;
    left: 16px;
    position: absolute;
    z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    display: block;
  }
`;

InfoWithTooltip.defaultProps = {
  width: null,
};

export default InfoWithTooltip;



// WEBPACK FOOTER //
// ./src/Components/InfoWithTooltip/index.js